var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectedIcon = function SvgSelectedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5251F6",
    fillRule: "evenodd",
    d: "M14.667 8.5a6.666 6.666 0 1 0-13.333 0 6.666 6.666 0 0 0 13.333 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5251F6",
    fillRule: "evenodd",
    d: "M14.667 8.5a6.666 6.666 0 1 0-13.333 0 6.666 6.666 0 0 0 13.333 0",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#selected-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.38 6.548c.174.179.262.268.277.375a.3.3 0 0 1-.001.105c-.018.106-.108.194-.287.368l-3.3 3.218c-.35.341-.525.512-.736.545a.7.7 0 0 1-.205 0c-.21-.033-.385-.204-.735-.545L4.631 8.896c-.18-.174-.269-.262-.287-.368a.3.3 0 0 1-.001-.105c.015-.107.103-.196.277-.375l.093-.096c.175-.179.262-.268.369-.287a.3.3 0 0 1 .104 0c.107.015.197.102.376.276l1.46 1.424c.087.085.13.128.183.136a.2.2 0 0 0 .051 0c.053-.008.097-.051.184-.136l2.998-2.924c.18-.174.269-.261.376-.277a.3.3 0 0 1 .104.001c.107.019.194.108.369.287z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "selected-icon_svg__a",
    width: 11.321,
    height: 9.006,
    x: 2.339,
    y: 4.161,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2669_4336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2669_4336",
    result: "shape"
  })))));
};
export default SvgSelectedIcon;